var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-information"},[_c('p',{staticClass:"item-information__label font-effra-light"},[_vm._v(_vm._s(_vm.label))]),_c('p',{staticClass:"item-information__value font-gilroy"},[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }